<template>
  <div class="operator-step-one_block">
    <img class='base_image' src='@/assets/image/pages/information/usages/op_five_steps.png'>
    <h3 class="large_blue_label">1. 作業可能時間登録</h3>
    <p>その日作業が可能な時間を入力します。</p>
    <div>
      <div class="left">
        <img class='base_image' src='@/assets/image/pages/information/usages/op_five_steps_1_upload.png'>
      </div>
      <div class="right">
        <img class='base_image' src='@/assets/image/pages/information/usages/op_five_steps_1_ex.png'>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "OperatorStepOneBlock"
  }
</script>

<style lang="scss" scoped>
  .operator-step-one_block {
    width: 90%;

    > .large_blue_label {
      margin: 2rem 0;
    }

    > div {
      @include double_columns(45%, 45%);
      margin: 2rem 0;

      @media screen and (max-width: 767px) {
        > .right > .base_image {
          margin: 2rem auto 0 auto;
        }
      }
    }
  }
</style>